import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<svg width=\"49\" height=\"48\" viewBox=\"0 0 49 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"0.666504\" width=\"48\" height=\"48\" fill=\"white\"></rect><rect x=\"4.6665\" y=\"15\" width=\"17\" height=\"20\" rx=\"1\" stroke=\"#475467\" stroke-width=\"2\"></rect><line x1=\"27.6665\" y1=\"25\" x2=\"44.6665\" y2=\"25\" stroke=\"#475467\" stroke-width=\"2\" stroke-linecap=\"round\"></line><line x1=\"27.6665\" y1=\"21\" x2=\"44.6665\" y2=\"21\" stroke=\"#475467\" stroke-width=\"2\" stroke-linecap=\"round\"></line><line x1=\"27.6665\" y1=\"29\" x2=\"32.6665\" y2=\"29\" stroke=\"#475467\" stroke-width=\"2\" stroke-linecap=\"round\"></line></svg>", 1)
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
  fillColor: { type: String, default: '#fff' },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_2))
}
}

})